












































import Vue from "vue";
import isEmpty from "lodash-es/isEmpty";

export interface GridRow {
  Fields: (string | number)[];
  RowId?: string;
}

export interface GridData {
  Rows: GridRow[];
}

export default Vue.extend({
  props: {
    columnCols: {
      required: true,
      default: [12]
    },
    columnHeaders: {
      type: Object,
      required: true
    },
    columnTotals: {
      type: Object,
      required: true
    },
    columnTotalindex: {
      type: Number,
      required: false,
      default: 1
    },
    gridData: {
      type: Object,
      required: true,
      default: () => {
        return {
          Rows: [{ RowId: "Id1", Fields: ["txt"] }]
        } as GridData;
      }
    }
  },
  data() {
    return {
      selectedRowId: null as null | string
    };
  },

  methods: {
    rowSelectable(row: GridRow): boolean {
      if (!isEmpty(row.Fields) && row.Fields[this.columnTotalindex] === 0) {
        return false;
      }
      return true;
    },
    rowSelected(row: GridRow): boolean {
      if (!isEmpty(row.Fields) && row.Fields[this.columnTotalindex] === 0) {
        return false;
      }
      return this.selectedRowId === row.RowId;
    },
    getCols: function(index: number): number {
      return this.columnCols[index];
    },
    onClicked(row: GridRow, isTotal: boolean) {
      if (!isEmpty(row.Fields) && row.Fields[this.columnTotalindex] === 0) {
        return;
      }

      if (this.selectedRowId === row.RowId) {
        this.selectedRowId = null;
        this.$emit("row-deselected");
      } else if (!!row.RowId) {
        this.selectedRowId = row.RowId;
        this.$emit("row-selected", {
          IsTotalRow: !!isTotal,
          Id: !!isTotal ? null : row.RowId
        });
      }
    }
  }
});
